
import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Engineeringdesign.css';
import '../styles/Servicehero2.css'; // Ensure this is imported
import backgroundImage from '../assets/Pic-18.jpeg';
import smallImage from '../assets/electricaldesign.jpg';

const carouselText = [
  "SINGLE LINE DIAGRAMS", "ELECTRICAL SCHEMATICS", "PRIMARY AND SECONDARY DRAWINGS",
  "CABLE SCHEDULING DOCUMENTATION", "CABLE SIZING CALCULATIONS", "PANEL AND SWITCHYARD DRAWINGS"
];

const Engineeringdesign = () => {
   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />

      {/* Top Design Section */}
      <div
        className="engineeringdesign-container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="engineeringdesign-content">
          <div className="text-section fade-in-up">
            <h1>Engineering Design</h1>
            <p>
              Electrical design is a critical element of successful engineering projects.
              Our electrical engineering design and drafting services are delivered by professionals.
              We are a team of engineers and draftsmen well-versed in current codes and standards,
              with rich experience in the field.
            </p>
          </div>
          <div className="image-section fade-in-up">
            <img src={smallImage} alt="Engineering Design" />
          </div>
        </div>
      </div>

      {/* Feature Boxes */}
      <div className="feature-boxes-wrapper">
        <div className="box-grid">
          {[
            { title: 'FOCUSED DESIGNING', description: 'We emphasize logical information while working on projects of all sizes. This approach helps solve problems efficiently.' },
            { title: 'FINE DELIVERABLES', description: 'We ensure timely outcomes with attention to detail through proven systems and processes.' },
            { title: 'PROFESSIONAL TEAM', description: 'Our team undergoes regular training to maintain high professional standards and minimize risks.' },
            { title: 'SOFTWARE AS A TOOL', description: 'Our software platforms are built to meet and exceed design codes and standards.' },
            { title: 'TICKETING SYSTEM', description: 'We provide robust communication and support systems to track all client service history.' },
            { title: 'CLIENT RAPPORT', description: 'We continuously improve our services to meet client needs and enable customizations.' },
          ].map((box, idx) => (
            <div key={idx} className="feature-box fade-in-up" style={{ animationDelay: `${idx * 0.2}s` }}>
              <h3>{box.title}</h3>
              <p>{box.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Infinite Scrolling Text */}
      <section className="servicehero2-section">
        <article className="servicehero2-carousel">
          <div className="servicehero2-track">
            <div className="servicehero2-list">
              {[...carouselText, ...carouselText].map((text, index) => (
                <div key={index} className="servicehero2-item">{text}</div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <Footer />
    </>
  );
};

export default Engineeringdesign;
